import React from "react";
import { NavLink, useHistory } from "react-router-dom";
// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
// Custom components
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
// Assets
import { apiurl } from "APIURL";
import illustration from "assets/img/auth/auth.jpg";
import axios from "axios";
import { FcGoogle } from "react-icons/fc";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { decodeToken } from "react-jwt";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getProfileData,
  getUserData,
  setProfile,
  setUser,
} from "redux/slices/userSlice";

function SignIn() {
  // Chakra color mode
  const history = useHistory();
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const googleBg = useColorModeValue("secondaryGray.300", "whiteAlpha.200");
  const googleText = useColorModeValue("navy.700", "white");
  const googleHover = useColorModeValue(
    { bg: "gray.200" },
    { bg: "whiteAlpha.300" }
  );
  const googleActive = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.200" }
  );
  const toast = useToast();
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUserData);
  const [show, setShow] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const userrofile = useAppSelector(getProfileData);
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const handleClick = () => setShow(!show);
  const handleSubmit = async (
    event: React.FormEvent,
    email: string,
    password: string
  ) => {
    event.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(`${apiurl}/auth/signin`, {
        email,
        password,
      });

      localStorage.setItem("user", JSON.stringify(response.data));
      const token = response.data.access_token;
      localStorage.setItem("token", token);
      const decoded: any = decodeToken(token);
      localStorage.setItem("userId", decoded.sub);
      toast({
        title: "Vous étes connecté",
        description: "Veillez patienter ...",
        duration: 1000,
        isClosable: true,
        status: "success",
        position: "top",
      });

      dispatch(setUser(JSON.parse(window.localStorage.getItem("user"))));

      dispatch(
        setProfile({
          birthdate: new Date(),
          image: "",
          lastModifiedOn: new Date(),
          level: 3,
          rating: 5.6,
          userId: user.id,
          ...user,
        })
      );
      setLoading(false);
      if (localStorage.getItem("role") === "1") history.push("/admin");
      if (localStorage.getItem("role") === "5")
        history.push("/formateur/formations");
      else history.push("/user/formations");
    } catch (err) {
      setLoading(false);
      if (err.response.data.message) {
        const errorMessage = err.response.data.message;
        if (errorMessage === "not") {
          toast({
            title: "Erreur de connexion",
            description: "Informations invalides",
            duration: 1000,
            isClosable: true,
            status: "error",
            position: "top",
          });
        } else if (errorMessage === "User account deactivated") {
          toast({
            title: "Erreur de connexion",
            description: " Compte désactivé ",
            duration: 1000,
            isClosable: true,
            status: "error",
            position: "top",
          });
        }
      } else {
        toast({
          title: "Erreur de connexion",
          description: "Veillez vérifier vos données",
          duration: 1000,
          isClosable: true,
          status: "error",
          position: "top",
        });
      }
    }
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w="100%"
        mx={{ base: "auto", lg: "0px" }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px", md: "14vh" }}
        flexDirection="column"
      >
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px">
            Connectez-vous
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Entre votre email et mot de pass pour se connecter!
          </Text>
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: "100%", md: "420px" }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: "auto", lg: "unset" }}
          me="auto"
          mb={{ base: "20px", md: "auto" }}
        >
          <Button
            fontSize="sm"
            me="0px"
            mb="26px"
            py="15px"
            h="50px"
            borderRadius="16px"
            bg={googleBg}
            color={googleText}
            fontWeight="500"
            _hover={googleHover}
            _active={googleActive}
            _focus={googleActive}
          >
            <Icon as={FcGoogle} w="20px" h="20px" me="10px" />
            Connecter avec Google
          </Button>
          <Flex align="center" mb="25px">
            <HSeparator />
            <Text color="gray.400" mx="14px">
              ou
            </Text>
            <HSeparator />
          </Flex>
          <form action="" onSubmit={(e) => handleSubmit(e, email, password)}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Email<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="email"
                placeholder="mail@@tunisietelecom.tn"
                mb="24px"
                fontWeight="500"
                size="lg"
              />
              <FormLabel
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                display="flex"
              >
                Mot de passe <Text color={brandStars}>*</Text>
              </FormLabel>
              <InputGroup size="md">
                <Input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  isRequired={true}
                  fontSize="sm"
                  placeholder="Min. 8 characters"
                  mb="24px"
                  size="lg"
                  type={show ? "text" : "password"}
                  variant="auth"
                />
                <InputRightElement display="flex" alignItems="center" mt="4px">
                  <Icon
                    color={textColorSecondary}
                    _hover={{ cursor: "pointer" }}
                    as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                    onClick={handleClick}
                  />
                </InputRightElement>
              </InputGroup>
              <Flex justifyContent="space-between" align="center" mb="24px">
                <FormControl display="flex" alignItems="center">
                  <Checkbox
                    id="remember-login"
                    colorScheme="brandScheme"
                    me="10px"
                  />
                  <FormLabel
                    htmlFor="remember-login"
                    mb="0"
                    fontWeight="normal"
                    color={textColor}
                    fontSize="sm"
                  >
                    Rester connecté
                  </FormLabel>
                </FormControl>
                <NavLink to="/auth/forgot-password">
                  <Text
                    color={textColorBrand}
                    fontSize="sm"
                    w="124px"
                    fontWeight="500"
                  >
                    Mot de passe oublié ?
                  </Text>
                </NavLink>
              </Flex>
              <Button
                type="submit"
                fontSize="sm"
                variant="brand"
                fontWeight="500"
                w="100%"
                h="50"
                mb="24px"
              >
                {loading === false ? (
                  "Connecter"
                ) : (
                  <Spinner color={"gray.50"} />
                )}
              </Button>
            </FormControl>
          </form>
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="start"
            maxW="100%"
            mt="0px"
          >
            <Text color={textColorDetails} fontWeight="400" fontSize="14px">
              Pas de compte?
              <NavLink to="/auth/sign-up">
                <Text
                  color={textColorBrand}
                  as="span"
                  ms="5px"
                  fontWeight="500"
                >
                  Créer un compte
                </Text>
              </NavLink>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
